import type { FC } from "react"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"

interface SalesOrderFreightRemovalDialogProps {
  onClose: () => void
  onConfirm: () => void
}

export const SalesOrderFreightRemovalDialog: FC<SalesOrderFreightRemovalDialogProps> = ({ onClose, onConfirm }) => (
  <ConfirmationDialog
    title='Remove Freight Line'
    content='Changing freight terms will remove the freight line and all associated data. This cannot be undone.'
    closeLabel='Cancel'
    confirmLabel='Remove'
    isWarning
    testIdPrefix='customer-orders.so-freight-removal-dialog'
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
